import React from "react"
import { formatCurrency } from "./formatters"

const InvoiceItem = ({ label, value, currency, boldLabel = false }) => {
  return (
    <div className="flex flex-row justify-between items-center gap-2">
      <p className={`${boldLabel ? "font-bold" : ""}`}>{label}</p>
      <p>{value === 0 ? "TBD" : formatCurrency(value, currency)}</p>
    </div>
  )
}

export default InvoiceItem
